export default "__VITE_ASSET__BLnLOI8Y__"